// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2SPwP","name":"ConsentHeader_name__iQ0I7","birthday":"ConsentHeader_birthday__wzWc3","skeleton":"ConsentHeader_skeleton__2CYZ2"};